/**
 * Judge.me renders its sort dropdown as a native <select>, whose open option
 * list can't be styled cross-browser. This swaps in a small custom listbox
 * driven off that same <select> (so Judge.me's own change handler still
 * fires), keeping the native element as the source of truth.
 *
 * The widget can be injected or re-rendered by Judge.me's script at any time,
 * and there's no hook for "widget ready". A previous version of this watched
 * the whole document with a MutationObserver, which fired on every node
 * Judge.me added (including the ones this script itself was inserting) and
 * froze the page. Bounded polling with a single cheap querySelector per tick
 * avoids that: fixed, small cost, no feedback loop.
 */
(function () {
  var POLL_MS = 500;

  function currentLabel(select) {
    var opt = select.options[select.selectedIndex];
    return opt ? opt.textContent : '';
  }

  function buildCustomSelect(select) {
    select.dataset.customSelectBound = 'true';
    select.classList.add('jdgm-visually-hidden-select');

    var wrapper = document.createElement('div');
    wrapper.className = 'jdgm-custom-select';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'jdgm-custom-select__trigger';
    trigger.textContent = currentLabel(select);

    var list = document.createElement('ul');
    list.className = 'jdgm-custom-select__list';
    list.hidden = true;

    function renderOptions() {
      list.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (opt) {
        var li = document.createElement('li');
        li.className = 'jdgm-custom-select__option';
        li.textContent = opt.textContent;
        if (opt.selected) li.setAttribute('aria-selected', 'true');
        li.addEventListener('click', function () {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          trigger.textContent = opt.textContent;
          closeList();
        });
        list.appendChild(li);
      });
    }

    function openList() {
      renderOptions();
      list.hidden = false;
      wrapper.classList.add('is-open');
    }

    function closeList() {
      list.hidden = true;
      wrapper.classList.remove('is-open');
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      if (list.hidden) openList(); else closeList();
    });
    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) closeList();
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(list);
    select.insertAdjacentElement('afterend', wrapper);
  }

  function tick() {
    var select = document.querySelector('.jdgm-sort-dropdown:not(.jdgm-visually-hidden-select)');
    if (select) buildCustomSelect(select);
  }

  document.addEventListener('DOMContentLoaded', function () {
    tick();
    setInterval(tick, POLL_MS);
  });
})();
